import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {SmartTopUpPromo} from 'models';
import {ImageInterface} from '../../../../../app-shared/models/image.interface';

@Component({
  selector: 'sb-display-input-checkbox-toggle',
  templateUrl: './display-input-checkbox-toggle.component.html',
  styleUrls: ['./display-input-checkbox-toggle.component.scss']
})
export class DisplayInputCheckboxToggleComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() info: string;
  @Input() statusKey: string;
  @Input() images: ImageInterface[];
  @Input() control: FormControl;
  @Input() checked: boolean;
  @Input() lean: boolean;
  @Input() invalid: boolean;
  @Input() iconSize = 'normal';
  @Input() smartTopUpPromo: SmartTopUpPromo;
  @Input() deltagiga!: number;
  @Input() hasDoublePO!: boolean;

  ngOnInit() {
  }

  get smartPopupPromoText() {
    if (this.smartTopUpPromo && this.smartTopUpPromo.title) {
      return `<p>${this.smartTopUpPromo.title.replace('{{deltagiga}}', String(this.deltagiga))}</p>`;
    }
  }

  public isChecked(): boolean {
    return !!this.control.value;
  }
}
